<template>
  <el-tabs type="border-card" v-model="activeName">
    <el-tab-pane
      v-for="(item, index) in eventOptions"
      :key="index"
      :name="item.shipType"
      :label="`${item.name}(${(targetEventModel(item) && targetEventModel(item).targetTempId !== -1) ? 1 : 0 })`"
    >
      <TargetEventItem
        :ship-type="item.shipType"
        :partner-id="partnerId"
        :model="targetEventModel(item)"
        :disabled="disabled"
        :eventTempList="eventTempList"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import TargetEventItem from './TargetEventItem.vue'
import { eventOptions } from '@/views/advertisement/creative/MaterialCreative'

export default {
  components: {
    TargetEventItem
  },
  inject: ['eventTempList'],
  props: {
    partnerId: { type: Number, default: 0 },
    keyEventList: { type: Array, default: () => [] },
    autoEventList: { type: Array, default: () => [] },
    voiceEventList: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      activeName: 'KEY',
      eventOptions,
    }
  },
  computed: {
    targetEventModel(item) {
      return function (item) {
        return this[item.key][0]
      }
    }
  },
}
</script>

<style lang="stylus" scoped>

</style>
